import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import PartnershipHero from './components/PartnershipHero';
import PartnerTypesSection from './components/PartnerTypesSection';
import SuitableForSection from './components/SuitableForSection';
import CoopProcessSection from './components/CoopProcessSection';
import OdmOemSection from './components/OdmOemSection';
import CoopAdvantagesSection from './components/CoopAdvantagesSection';
import PartnershipFaqSection from './components/PartnershipFaqSection';
import PartnershipCtaSection from './components/PartnershipCtaSection';

export default function PartnershipPage() {
  useSEO({
    title: '合作相關｜ODM OEM 保健食品代工合作方案｜康永生技',
    description: '了解康永生技保健食品 ODM/OEM 代工合作方案：8大步驟從諮詢到交貨，支援少量訂單，250+ 品牌合作經驗，完整法規支援。',
    keywords: 'ODM OEM合作,保健食品代工合作,少量代工,品牌代工,康永合作流程',
    lang: 'zh-TW',
    canonicalPath: '/partnership',
  });

  return (
    <Layout>
      <SEOJsonLd
        type="WebPage"
        pageTitle="合作相關｜ODM OEM 保健食品代工合作方案｜康永生技"
        pageDescription="了解康永生技保健食品 ODM/OEM 代工合作方案，支援少量訂單及完整法規支援。"
        pageUrl="https://kangyong.com/partnership"
      />
      <PartnershipHero />
      <PartnerTypesSection />
      <SuitableForSection />
      <CoopProcessSection />
      <OdmOemSection />
      <CoopAdvantagesSection />
      <PartnershipFaqSection />
      <PartnershipCtaSection />
    </Layout>
  );
}
